import { render, staticRenderFns } from "./items-list.vue?vue&type=template&id=1c4931f8&scoped=true&"
import script from "./items-list.vue?vue&type=script&lang=js&"
export * from "./items-list.vue?vue&type=script&lang=js&"
import style0 from "./items-list.vue?vue&type=style&index=0&id=1c4931f8&scoped=true&lang=css&"
import style1 from "./items-list.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c4931f8",
  null
  
)

export default component.exports